import { addDays, format, startOfWeek } from "date-fns"

export type FormValues = {
  id: string
  week: number
  projectId: string
  rowIndex: number
  columnIndex: number
  whatsAppName: string
  region: string
  jobDate: any
  location: string
  postCode: string
  jobDescription: string
  shiftType: number
  rateTypeId?: any,
  requiredWorkers: number
  jobStatus: number
  startTime: any
  endTime: any
  hours: number
  clientSiteContact: any
  onCallNumber: any
  jobNumber: any
  labourOrderNR: any
  additionalInformation: any
  invoice: any
  plants_Materials: any
  vehicleRegistration: any
  hotelStatus: any
  latitude: any
  longitude: any
}

export const formatFieldValue = (field: string, value: any) => {
  if (field === 'startTime' || field === 'endTime') {
    return format(new Date(`2024-01-01T${value}:00`), "yyyy-MM-dd'T'HH:mm:ss");
  }
  if (field === 'requiredWorkers' || field === 'hours') {
    return Number(value);
  }
  return value;
};

export const formatDiffs = (changes: any) => {
  return changes
    .filter((d: any) => d.kind === 'E')
    .map((d: any) => ({
      property: d.path[0],
      oldValue: d.lhs,
      newValue: d.rhs
    }));
};

export const removeObject = (array: any, rowIndex: any, colIndex: any) => {
  return array.filter((item: any) => !(item.rowIndex === rowIndex && item.colIndex === colIndex));
};

export const getWeekStartingFromSaturday = (date: Date) => {
  const saturday = startOfWeek(date, { weekStartsOn: 6 });
  return Array.from({ length: 8 }).map((_, i) => {
    const day = addDays(saturday, i);
    return {
      day: format(day, 'yyyy-MM-dd'),
      date: format(day, 'dd/MM/yyyy'),
      dayOfWeek: format(day, 'EEEE')
    };
  });
};
